
{
  "fr": {
    "configurator_preview": {
      "loading": "Chargement en cours…",
      "toggleModal": "Voir l'image générée"
    }
  }
}
